module.exports = __webpack_public_path__ + "static/rudi-afd61fa97924517d1910980cfb299f89.svg";